import React from 'react';

import axios from 'axios';

import Header from '../../Header';
import Sidebar from '../../Sidebar';
import PageHeader from '../../PageHeader';
import WinesTable from '../../Table/WinesTable';

import elements from '../Elements/elements';

// Criado um filtro costumizável, o usuário clica em adicionar novo filtro e a tabela recarrega com os dados selecionados. A seleção de colunas do usuário fica salvo no localstorage

export default function CustomFilter() {

  const [winesTable, setWinesTable] = React.useState(null);
  // ...
  const [filters, setFilters] = React.useState()
  const [optionInput, setOptionInput] = React.useState([])
  const [headersFilter, setHeadersFilter] = React.useState([])

  // ...
  React.useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/wines`)
      .then((response) => {
        setWinesTable(response.data);
      });

    if ((localStorage.getItem('configsFilter')) && (localStorage.getItem('optionInput'))) {
      setHeadersFilter(JSON.parse(localStorage.getItem('configsFilter')))
      setOptionInput(JSON.parse(localStorage.getItem('optionInput')))
    }
  }, []);

  let arrayFilters = []
  // Add item na coluna
  function addItem(e) {
    if (filters !== {} && filters !== undefined && e.target.value !== 'Selecione' && optionInput.includes(filters) === false) {
      setOptionInput([...optionInput, filters])
      console.log(filters)
      let { name, id } = Object.entries(elements).filter(elements => elements[1].name === filters)[0][1]
      console.log(name, id)
      arrayFilters.push({ Header: name, accessor: id })
      console.log(arrayFilters)
      const addedItem = [...headersFilter, { Header: name, accessor: id, Footer: '' }]
      setHeadersFilter(addedItem);
      localStorage.setItem('configsFilter', JSON.stringify(addedItem))
      localStorage.setItem('optionInput', JSON.stringify([...optionInput, filters]))

    }
  }
  // Remover item da coluna
  function removeItem(e) {
    const removedItemFilter = optionInput.filter(optionInput => optionInput !== e.target.getAttribute('data-id'));
    setOptionInput(removedItemFilter);
    const removedItemHeader = headersFilter.filter(headersFilter => headersFilter.Header !== e.target.getAttribute('data-id'));
    setHeadersFilter(removedItemHeader);
    localStorage.setItem('optionInput', JSON.stringify(removedItemFilter));
    localStorage.setItem('configsFilter', JSON.stringify(removedItemHeader));
  }
  // Aqui acontece o calculo do Footer da coluna.
  headersFilter.forEach(element => {
    if (element.Header === 'Quantidade') {
      element.Footer = info => {
        let count = info.rows.reduce((sum, row) => row.values.quantidade + sum, 0)
        return (<>{count}</>)
      }
    }
    if (element.Header === 'Preço') {
      element.Footer = info => {
        let count = info.rows.reduce((sum, row) => Number(row.values.preco) * row.values.quantidade + sum, 0)
        return (<>{count}</>)
      }
    }
  })

  // ...
  const columns = React.useMemo(
    () => [
      ...headersFilter,
      {
        Header: 'Actions',
        accessor: 'id',
        disableFilters: true,


        Cell: (row) => {
          const editItem = (value) => {
            window.location.href = `/wines/edit/${row.value}`
          };
          const deleteItem = () => {
            axios.delete(`${process.env.REACT_APP_API_URL}/wines/${row.value}/`).then((res) => {
              if (res.data) {
                window.location.href = '/wines/filter';
              }
            });
          };
          return (
            <div>
              <button
                onClick={editItem}
                className="bg-dark-1 hover:bg-dark-2 text-white font-semibold hover:text-white py-1 px-1 border border-blue-500 hover:border-transparent rounded mr-2"
              >
                Edit
              </button>
              <button
                onClick={deleteItem}
                className="bg-dark-1 hover:bg-dark-2 text-white font-semibold hover:text-white py-1 px-1 border border-blue-500 hover:border-transparent rounded mr-2"
              >
                Delete
              </button>
            </div>
          );
        },
      },
    ],
    [headersFilter],
  );

  return (
    <div className="flex">
      <Sidebar />
      <div className="content">
        <Header />
        <PageHeader
          title="Wines Listing"
          RigthActionButtonTitle="Incluir Novo Vinho"
          RigthActionButtonRoute={'/wines/create'}
        />
        <form>
          <select className='intro-y mx-1 bg-dark-1 text-white focus:outline-none  p-1 whitespace-nowrap select-form' defaultValue={'Selecione'} onChange={(e) => setFilters(e.target.value)}>
            <option disabled >Selecione</option>
            {Object.entries(elements).map((one, i) => {
              if (one[1].name !== 'Imagem') {
                return <option key={i} value={one[1].name}>{one[1].name}</option>
              }
            })}
          </select>
          <button type="button" onClick={(e) => addItem(e)} className='intro-y bg-dark-2 text-white px-2 shadow-md mr-2'>+</button>
        </form>
        <div className="flex">
          {Object.entries(optionInput).map((select, i) => {
            return (
              <div className="intro-y flex justify-center items-center py-4 px-2" key={i}>
                <div className="mr-2" >
                  {Object.values(select)[1]}
                </div>
                <button type="button" data-id={Object.values(select)[1]} onClick={(e) => removeItem(e)} className=' bg-dark-1 hover:bg-dark-2 text-white font-semibold hover:text-white py-1 px-1 border border-blue-500 hover:border-transparent rounded px-2 mr-2'>-</button>
              </div>
            )
          })}
        </div>
        <div className="mt-8">
          {(winesTable && headersFilter.length > 0) ? <WinesTable columns={columns} data={winesTable} /> : null}
        </div>
      </div>
    </div >
  );
}




